<script>
/* eslint no-unused-vars: 'off' */
import myAnalysis from "@/components/myAnalysis/myAnalysis.vue";
import current from "@/scripts/current";
import common from "@/scripts/common";

export default {
    props: ['router', 'forReport'],
    components: {
        myAnalysis
    },
    render(h) {
        const vm = this;

        let cells = [
            {
                name: 'Equation',
                display: vm.getEquation()
            }
        ];

        let myAnalysis = h('my-analysis', {
            ref: 'myAnalysis',
            props: {
                router: vm.router,
                forReport: vm.forReport,
                tableType: 'Logistic Regression',
                cells
            }
        });
        return myAnalysis;
    },
    data: function () {
        return { cells: [] };
    },
    methods: {
        getEquation
        // getHeight: () => {
        //   const vm = this;
        //   return vm.$refs.myAnalysis ? vm.$refs.myAnalysis.getHeight() : 0;
        // },
    }
};

function isNotEmpty(s) {
    return s && s.length > 0;
}

function getEquation() {
    var vm = this;
    var selectionModel = current.selectionModel;
    if (
        selectionModel.v.dependent === null ||
        selectionModel.v.dependent.variable === null
    )
        return '';

    let independent = current.selectionModel.v.independent
        .map((v, i) => v.toString())
        .filter((s) => isNotEmpty(s))
        .join(',<br/>');
    if (isNotEmpty(independent)) independent = '<br/>' + independent;

    let d = selectionModel.v.dependent.variable.toString();
    return d.length === 0
        ? ''
        : selectionModel.v.dependent.variable.toString() + ' = ' + independent;

    //   var variableNames = selectionModel.v.independent.map((v) => v.toString());
    //   return equation + " " + variableNames.join(", ");
}
</script>

<style scoped>
</style>